import React from 'react';
import { Input } from 'antd';
import "./shared.css";


const DescriptionInput = ({ value, onChange, name }) => {
  return (
      <Input name={name}
        placeholder="Description du formulaire"
        value={value}  variant="borderless"
        onChange={onChange}
        className='inputDescriptionTitle'
      />
  ); 
};
 
export default DescriptionInput;
